export const visit = (vm, at) => {
at({ "da": { "conversations-visitor-ui": { "pageTitleNotifications": { "newMessage": "Ny besked" } }, "conversationsVisitorUIPageTitleNotifications": { "newMessage": "Ny besked" } } });
};